<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAdmit_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M9.156 20c-.368 0-.735-.147-1.016-.442l-5.72-6.007a1.56 1.56 0 0 1 0-2.133c.562-.59 1.47-.59 2.032 0l4.704 4.94L19.548 5.442c.561-.59 1.47-.59 2.031 0a1.56 1.56 0 0 1 0 2.134L10.171 19.557c-.28.295-.647.443-1.015.443"
    />
</svg>
